import { render, staticRenderFns } from "./noteable_discussion.vue?vue&type=template&id=02ed4840&vue3"
import script from "./noteable_discussion.vue?vue&type=script&lang=js&vue3"
export * from "./noteable_discussion.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports